import {
  MerchantFulfillmentRateEntity,
  MerchantFulfillmentStatus,
} from "@features/user/domain";
import { MerchantFulfillmentRateModel } from "../types";

export function mapMerchantFulfillmentRate(
  data: MerchantFulfillmentRateModel,
): MerchantFulfillmentRateEntity {
  return {
    lockingFulfillmentRate: data.locking_fulfillment_rate,
    lockingFulfillmentStatus: mapLockingFulfillmentStatus(
      data.locking_fulfillment_rate,
      data.rates_thresholds,
    ),
    lockingFulfillmentThresholds: {
      low: data.rates_thresholds.locking_fulfillment_low_threshold,
      medium: data.rates_thresholds.locking_fulfillment_medium_threshold,
      high: data.rates_thresholds.locking_fulfillment_high_threshold,
    },
  };
}

function mapLockingFulfillmentStatus(
  rate: number,
  thresholds: MerchantFulfillmentRateModel["rates_thresholds"],
): MerchantFulfillmentStatus {
  // old condition, not sure if still applicable but left just in case. "if no thresholds are returned"
  if (!thresholds?.locking_fulfillment_low_threshold) {
    return MerchantFulfillmentStatus.LOW;
  }

  if (rate <= thresholds.locking_fulfillment_low_threshold) {
    return MerchantFulfillmentStatus.LOW;
  }

  if (
    rate > thresholds.locking_fulfillment_low_threshold &&
    rate < thresholds.locking_fulfillment_high_threshold
  ) {
    return MerchantFulfillmentStatus.MEDIUM;
  }

  return MerchantFulfillmentStatus.HIGH;
}
